import { Injectable } from "@angular/core";
import { EMPTY, catchError, from, map, mergeMap, of } from "rxjs";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as customerActions from "./customer.actions";
import * as errorActions from "../../core/error/ngrx/error.actions";
import { DataService } from "src/app/supabase/services/data.service";
import { AuthService } from "src/app/supabase/services/auth.service";

@Injectable()
export class CustomerEffects {
    constructor(
        private actions$: Actions,
        private dataService: DataService,
        private authService: AuthService,
    ) {}

    loadCustomer$ = createEffect(() => this.actions$.pipe(
        ofType(customerActions.loadCustomer),
        mergeMap(() => 
          from(this.dataService.getCustomer()).pipe(
            map(customer => customerActions.loadCustomerSuccess({customer})),
            catchError((error) => of(errorActions.handleError({error: "Die Benutzerdaten konnten nicht geladen werden.", showToast: false, exception: error})))
          )
        )
      ));

    updateCustomer$ = createEffect(() => this.actions$.pipe(
        ofType(customerActions.updateCustomer),
        mergeMap(({customer}) => 
          from(this.dataService.updateCustomer(customer)).pipe(
            map(() => customerActions.updateCustomerSuccess({customer})),
            catchError((error) => of(errorActions.handleError({error: "Die Benutzerdaten konnten nicht aktualisiert werden.", exception: error})))
          )
        )
      ));
}
